export const getFileExtension = (str: string): string | null => {
  const lastDotIndex = str.lastIndexOf(".");
  if (lastDotIndex === -1 || lastDotIndex === str.length - 1) return null;

  return str.slice(lastDotIndex + 1);
};
